import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay, Button
} from '@chakra-ui/react';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface StoragePermissionDialogProps {
  validateStoragePermission: () => void;
}

const StoragePermissionDialog: React.FC<StoragePermissionDialogProps> = ({
  validateStoragePermission,
}) => {
  const contineuRef = useRef(null);
  const { t } = useTranslation();

  return (
    <AlertDialog
      isOpen={true}
      leastDestructiveRef={contineuRef}
      onClose={() => {}}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {t('permission.storage.required')}
          </AlertDialogHeader>

          <AlertDialogBody>{t('permission.storage.reason')}</AlertDialogBody>

          <AlertDialogFooter>
            <Button
              colorScheme="blue"
              ref={contineuRef}
              onClick={validateStoragePermission}
            >
              {t('permission.storage.continue')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default StoragePermissionDialog;
